<template>
  <div class="dispicker-wrapper">
    <el-select 
     :class="province ? 'is-select' : ''"
      v-model="province" 
      placeholder="省" 
      @change="_provinceChange"
      >
      <el-option
        v-for="(value, key) in provinceObj"
        :key="key"
        :label="value"
        :value="key"
        >
      </el-option>
    </el-select>
    <el-select 
     :class="city ? 'is-select' : ''"
      v-model="city" 
      placeholder="市" 
      @change="_cityChange">
      <el-option
        v-for="(value, key) in cityObj"
        :key="key"
        :label="value"
        :value="key"
        >
      </el-option>
    </el-select>
    <el-select 
     :class="district ? 'is-select' : ''"
      v-model="district" 
      placeholder="区/县" 
      @change="_districtChange">
      <el-option
        v-for="(value, key) in districtObj"
        :key="key"
        :label="value"
        :value="key"
        >
      </el-option>
    </el-select>
    
  </div>
</template>
<script>
  
  import { dataDistpicker } from "../../../public/static/distpicker/tree-distpicker.js";
  export default {
    props: {
      provinceId: {
        type: [Number, String]
      },
      cityId: {
        type: [Number, String]
      },
      districtId: {
        type: [Number, String]
      },
    },
    data() {
      return {
        provinceObj: dataDistpicker[100000],
        cityObj: null,
        districtObj: null,
        province: null,
        city: null,
        district: null,
      }
    },
    watch: {
      provinceId: {
        immediate: true,
        handler(val) {
          if(val) {
            this._provinceChange(val, 'init');
            
          }
        }
      }
    },
    methods: {
      _areaChange() {
        let obj = {
          province: this.province,
          city: this.city,
          district: this.district,
        }
        this.$emit('handlerChange', obj);
      },
      /**
       * 省改变时，修改市的下拉列表数据
       * **/
      _provinceChange(val, type) {
        this.cityObj = dataDistpicker[val];
        this.districtObj = null;
        this.city = null;
        this.district = null;
        if(type === 'init') {
          this.province = val.toString();
          if(this.cityId) {
            this._cityChange(this.cityId, type);
          }
          return;
        }
        this._areaChange();
      },
      /**
       * 省改变时，修改市的下拉列表数据
       * **/
      _cityChange(val, type) {
        this.districtObj = dataDistpicker[val];
        this.district = null;

        if(type === 'init') {
          this.city = val.toString();
          if(this.districtId) {
            this._districtChange(this.districtId, type);
          }
         return;
        }
        this._areaChange();
      },
      /**
       * 省改变时，修改市的下拉列表数据
       * **/
      _districtChange(val, type) {
        if(type === 'init') {
          this.district = val.toString();
          return;
        }
        this._areaChange();
      },
    },
    created() {

    }
  }
</script>
<style lang="less">

</style>